import { getCookie, setCookie } from './_Utils';

/* eslint-disable */
const gdpr = () => {
    const EU = [
        'AL',
        'AD',
        'AM',
        'AT',
        'BY',
        'BE',
        'BA',
        'BG',
        'CH',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'FO',
        'FI',
        'FR',
        'GB',
        'GE',
        'GI',
        'GR',
        'HU',
        'HR',
        'IE',
        'IS',
        'IT',
        'LT',
        'LU',
        'LV',
        'MC',
        'MK',
        'MT',
        'NO',
        'NL',
        'PL',
        'PT',
        'RO',
        'RU',
        'SE',
        'SI',
        'SK',
        'SM',
        'TR',
        'UA',
        'VA',
    ];

    // const country = $('input[name="country_code"]').val();
    const country = localStorage.getItem('MM_COUNTRY_CODE');

    let inEU = false;
    if (EU.indexOf(country) > -1) {
        inEU = true;
    }

    function toggleBanner() {
        const banner = document.querySelector('.cl_gdpr_banner');
        banner.classList.toggle('cl_gdpr_banner--visible');
    }

    if (getCookie('cl_gdpr') !== '1' && inEU) {
        toggleBanner();
    }

    const x_button = document.querySelector('.cl_gdpr_banner__inner__x');
    x_button.addEventListener('click', () => {
        setCookie('cl_gdpr', '1', 30);
        toggleBanner();
    });
};

export { gdpr };

/* eslint-enable */
